import { notifyGenerationComplete } from './utils.js';

const moduleCache = new Map();
const exportCache = new Map();

function createLoaderSpec(path, load) {
  return { path, load };
}

const FAL_MODULE_LOADERS = {
  inpaint: createLoaderSpec('./inpaintService.js', () => import('./inpaintService.js')),
  qwenImageEdit: createLoaderSpec('./qwenImageEditService.js', () => import('./qwenImageEditService.js')),
  attributeSlider: createLoaderSpec('./attributeSliderService.js', () => import('./attributeSliderService.js')),
  cameraOrbit: createLoaderSpec('./cameraOrbitService.js', () => import('./cameraOrbitService.js')),
  attributeEditSpec: createLoaderSpec('./attributeEditSpecService.js', () => import('./attributeEditSpecService.js')),
  outpaint: createLoaderSpec('./outpaintService.js', () => import('./outpaintService.js')),
  upscale: createLoaderSpec('./upscaleService.js', () => import('./upscaleService.js')),
  smartResize: createLoaderSpec('./smartResizeService.js', () => import('./smartResizeService.js')),
  birefnet: createLoaderSpec('./birefnetService.js', () => import('./birefnetService.js')),
  flux2Pro: createLoaderSpec('./flux2ProService.js', () => import('./flux2ProService.js')),
  flux2Edit: createLoaderSpec('./flux2EditService.js', () => import('./flux2EditService.js')),
  nanoBanana2: createLoaderSpec('./nanoBanana2Service.js', () => import('./nanoBanana2Service.js')),
  nanoBanana2Edit: createLoaderSpec('./nanoBanana2EditService.js', () => import('./nanoBanana2EditService.js')),
  nanoBanana2Flash: createLoaderSpec('./nanoBanana2FlashService.js', () => import('./nanoBanana2FlashService.js')),
  nanoBanana2FlashEdit: createLoaderSpec('./nanoBanana2FlashEditService.js', () => import('./nanoBanana2FlashEditService.js')),
  grokImagine: createLoaderSpec('./grokImagineService.js', () => import('./grokImagineService.js')),
  grokImagineEdit: createLoaderSpec('./grokImagineEditService.js', () => import('./grokImagineEditService.js')),
  grokImagineVideo: createLoaderSpec('./grokImagineVideoService.js', () => import('./grokImagineVideoService.js')),
  objectRemovalMask: createLoaderSpec('./objectRemovalMaskService.js', () => import('./objectRemovalMaskService.js')),
  objectRemovalMaskless: createLoaderSpec('./objectRemovalMasklessService.js', () => import('./objectRemovalMasklessService.js')),
  depthEstimation: createLoaderSpec('./depthEstimationService.js', () => import('./depthEstimationService.js')),
  sam: createLoaderSpec('./samService.js', () => import('./samService.js')),
  evfSam: createLoaderSpec('./evfSamService.js', () => import('./evfSamService.js')),
  sam2AutoSegment: createLoaderSpec('./sam2AutoSegmentService.js', () => import('./sam2AutoSegmentService.js')),
  lucyRestyle: createLoaderSpec('./lucyRestyleService.js', () => import('./lucyRestyleService.js')),
  klingO1Edit: createLoaderSpec('./klingO1EditService.js', () => import('./klingO1EditService.js')),
  ltxVideo: createLoaderSpec('./ltxVideoService.js', () => import('./ltxVideoService.js')),
  klingO3: createLoaderSpec('./klingO3Service.js', () => import('./klingO3Service.js')),
  klingV3: createLoaderSpec('./klingV3ActualService.js', () => import('./klingV3ActualService.js')),
  veo31: createLoaderSpec('./veo31Service.js', () => import('./veo31Service.js')),
  geminiOmniFlashVideoEdit: createLoaderSpec('./geminiOmniFlashVideoEditService.js', () => import('./geminiOmniFlashVideoEditService.js')),
  happyHorseVideoEdit: createLoaderSpec('./happyHorseVideoEditService.js', () => import('./happyHorseVideoEditService.js')),
  wan27EditVideo: createLoaderSpec('./wan27EditVideoService.js', () => import('./wan27EditVideoService.js')),
  motionGuide: createLoaderSpec('./motionGuideService.js', () => import('./motionGuideService.js')),
  multicamActionBrief: createLoaderSpec('./multicamActionBriefService.js', () => import('./multicamActionBriefService.js')),
  recastCharacterVision: createLoaderSpec('./recastCharacterVisionService.js', () => import('./recastCharacterVisionService.js')),
  sam3VideoSelect: createLoaderSpec('./sam3VideoSelectService.js', () => import('./sam3VideoSelectService.js')),
  videoBackgroundRemoval: createLoaderSpec('./videoBackgroundRemovalService.js', () => import('./videoBackgroundRemovalService.js')),
  videoUpscale: createLoaderSpec('./videoUpscaleService.js', () => import('./videoUpscaleService.js')),
  briaGenfill: createLoaderSpec('./briaGenfillService.js', () => import('./briaGenfillService.js')),
  qwenImageLayered: createLoaderSpec('./qwenImageLayeredService.js', () => import('./qwenImageLayeredService.js')),
  icLightV2: createLoaderSpec('./icLightV2Service.js', () => import('./icLightV2Service.js')),
  kontextMaxVariation: createLoaderSpec('./kontextMaxVariationService.js', () => import('./kontextMaxVariationService.js')),
  trellis: createLoaderSpec('./trellisService.js', () => import('./trellisService.js')),
  tripo3d: createLoaderSpec('./tripo3dService.js', () => import('./tripo3dService.js')),
  hyper3dRodin: createLoaderSpec('./hyper3dRodinService.js', () => import('./hyper3dRodinService.js')),
  meshy: createLoaderSpec('./meshyService.js', () => import('./meshyService.js')),
  meshyRig: createLoaderSpec('./meshyRigService.js', () => import('./meshyRigService.js')),
  hunyuan3d: createLoaderSpec('./hunyuan3dService.js', () => import('./hunyuan3dService.js')),
  retexture: createLoaderSpec('./retextureService.js', () => import('./retextureService.js')),
  remesh: createLoaderSpec('./remeshService.js', () => import('./remeshService.js')),
  ideogramCharacter: createLoaderSpec('./ideogramCharacterService.js', () => import('./ideogramCharacterService.js')),
  klingO1Image: createLoaderSpec('./klingO1ImageService.js', () => import('./klingO1ImageService.js')),
  seedream45: createLoaderSpec('./seedream45Service.js', () => import('./seedream45Service.js')),
  seedream5Pro: createLoaderSpec('./seedream5ProService.js', () => import('./seedream5ProService.js')),
  gptImage25: createLoaderSpec('./gptImage25Service.js', () => import('./gptImage25Service.js')),
  gptImage25Inpaint: createLoaderSpec('./gptImage25InpaintService.js', () => import('./gptImage25InpaintService.js')),
  zImageTurboInpaint: createLoaderSpec('./zImageTurboInpaintService.js', () => import('./zImageTurboInpaintService.js')),
  seedanceVideo: createLoaderSpec('./seedanceVideoService.js', () => import('./seedanceVideoService.js')),
  minimaxH3Video: createLoaderSpec('./minimaxH3VideoService.js', () => import('./minimaxH3VideoService.js')),
  minimaxH3SpecialVideo: createLoaderSpec('./minimaxH3SpecialVideoService.js', () => import('./minimaxH3SpecialVideoService.js')),
  flux3Video: createLoaderSpec('./flux3VideoService.js', () => import('./flux3VideoService.js')),
  krea2: createLoaderSpec('./krea2Service.js', () => import('./krea2Service.js')),
  krea2Turbo: createLoaderSpec('./krea2TurboService.js', () => import('./krea2TurboService.js')),
  minimaxMusic: createLoaderSpec('./minimaxMusicService.js', () => import('./minimaxMusicService.js')),
  elevenLabsAudio: createLoaderSpec('./elevenLabsAudioService.js', () => import('./elevenLabsAudioService.js')),
  audioIsolation: createLoaderSpec('./audioIsolationService.js', () => import('./audioIsolationService.js')),
  audioStems: createLoaderSpec('./audioStemsService.js', () => import('./audioStemsService.js')),
  audioSection: createLoaderSpec('./audioSectionService.js', () => import('./audioSectionService.js')),
  audioRestyle: createLoaderSpec('./audioRestyleService.js', () => import('./audioRestyleService.js')),
  mmaudio: createLoaderSpec('./mmaudioService.js', () => import('./mmaudioService.js')),
  genericEndpoint: createLoaderSpec('./genericEndpointService.js', () => import('./genericEndpointService.js')),
};

export function getOrSetCache(cache, key, load) {
  if (cache.has(key)) {
    return cache.get(key);
  }

  const value = load();
  cache.set(key, value);

  // Dynamic import failures can be transient during Vite/HMR. Keep successful
  // loads cached, but evict rejected promises so the next attempt can recover.
  if (value && typeof value.then === 'function') {
    value.catch(() => {
      if (cache.get(key) === value) {
        cache.delete(key);
      }
    });
  }

  return value;
}

export function shouldRetryModuleImport(error, env = import.meta.env) {
  if (!env?.DEV) {
    return false;
  }

  const message = String(error?.message || '').toLowerCase();
  return message.includes('failed to fetch dynamically imported module')
    || message.includes('error loading dynamically imported module')
    || message.includes('importing a module script failed');
}

function retryDynamicImportWithCacheBust(path) {
  return import(/* @vite-ignore */ `${path}?t=${Date.now()}`);
}

export async function loadModuleWithDevRetry(
  load,
  path,
  {
    env = import.meta.env,
    retryImport = retryDynamicImportWithCacheBust,
  } = {},
) {
  try {
    return await load();
  } catch (error) {
    if (!shouldRetryModuleImport(error, env)) {
      throw error;
    }

    return retryImport(path);
  }
}

export function loadFalServiceModule(serviceKey) {
  const loaderSpec = FAL_MODULE_LOADERS[serviceKey];
  if (!loaderSpec) {
    throw new Error(`Unknown FAL service: ${serviceKey}`);
  }
  return getOrSetCache(moduleCache, serviceKey, () => (
    loadModuleWithDevRetry(loaderSpec.load, loaderSpec.path)
  ));
}

function getDefaultExportOrModule(mod) {
  return Object.prototype.hasOwnProperty.call(mod, 'default') ? mod.default : mod;
}

export function loadFalExport(serviceKey, exportName) {
  const cacheKey = `${serviceKey}:${exportName}`;
  return getOrSetCache(exportCache, cacheKey, async () => {
    const mod = await loadFalServiceModule(serviceKey);
    const service = getDefaultExportOrModule(mod);
    const value = mod[exportName] ?? service?.[exportName];
    if (typeof value !== 'function') {
      throw new Error(`Export "${exportName}" not found on FAL service "${serviceKey}"`);
    }
    return value;
  });
}

export function createLazyService(serviceKey) {
  return new Proxy({}, {
    get(_target, prop) {
      if (prop === 'then') return undefined;
      if (typeof prop !== 'string') return undefined;

      return async (...args) => {
        const mod = await loadFalServiceModule(serviceKey);
        const service = getDefaultExportOrModule(mod);
        const fn = service?.[prop] ?? mod?.[prop];
        if (typeof fn !== 'function') {
          throw new Error(`Method "${prop}" not found on FAL service "${serviceKey}"`);
        }
        const result = await fn(...args);
        notifyGenerationComplete();
        return result;
      };
    },
  });
}

export const loadFlux2ProGenerate = () => loadFalExport('flux2Pro', 'generateFlux2Pro');
export const loadFlux2EditGenerate = () => loadFalExport('flux2Edit', 'generateFlux2Edit');
export const loadNanoBanana2Generate = () => loadFalExport('nanoBanana2', 'generateNanoBanana2');
export const loadNanoBanana2EditGenerate = () => loadFalExport('nanoBanana2Edit', 'generateNanoBanana2Edit');
export const loadNanoBanana2FlashGenerate = () => loadFalExport('nanoBanana2Flash', 'generateNanoBanana2Flash');
export const loadNanoBanana2FlashEditGenerate = () => loadFalExport('nanoBanana2FlashEdit', 'generateNanoBanana2FlashEdit');
export const loadGrokImagineGenerate = () => loadFalExport('grokImagine', 'generateGrokImagine');
export const loadGrokImagineEditGenerate = () => loadFalExport('grokImagineEdit', 'generateGrokImagineEdit');
export const loadIdeogramCharacterGenerate = () => loadFalExport('ideogramCharacter', 'generateIdeogramCharacter');
export const loadIdeogramCharacterRemixGenerate = () => loadFalExport('ideogramCharacter', 'generateIdeogramCharacterRemix');
export const loadKlingO1ImageGenerate = () => loadFalExport('klingO1Image', 'generateKlingO1Image');
export const loadSeedream45Generate = () => loadFalExport('seedream45', 'generateSeedream45');
export const loadSeedream45EditGenerate = () => loadFalExport('seedream45', 'generateSeedream45Edit');
export const loadSeedream5ProGenerate = () => loadFalExport('seedream5Pro', 'generateSeedream5Pro');
export const loadSeedream5ProEditGenerate = () => loadFalExport('seedream5Pro', 'generateSeedream5ProEdit');
export const loadGptImage25Generate = () => loadFalExport('gptImage25', 'generateGptImage25');
export const loadGptImage25EditGenerate = () => loadFalExport('gptImage25', 'generateGptImage25Edit');
export const loadGenericFalEndpointGenerate = () => loadFalExport('genericEndpoint', 'generateTextToImage');
